import { IOption } from "../../../../../features/forms/fields/select-field/select-field.props";

export const MarketingSupportLevelOptions: IOption[] = [
  { value: "HIGH", label: "High" },
  { value: "MEDIUM", label: "Medium" },
  { value: "LOW", label: "Low" },
];
